import { render, staticRenderFns } from "./projectHelp.vue?vue&type=template&id=58e8a2f6&scoped=true"
import script from "./projectHelp.vue?vue&type=script&lang=js"
export * from "./projectHelp.vue?vue&type=script&lang=js"
import style0 from "./projectHelp.vue?vue&type=style&index=0&id=58e8a2f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e8a2f6",
  null
  
)

export default component.exports